import React, { Suspense } from "react";

import { Outlet } from "react-router-dom";
import NewSideBar from "../global/NewSideBar";
import { Box, useTheme } from "@mui/material";
import MainAppBar from "../global/MainAppBar/MainAppBar";
import useDeviceType from "../global/Hooks/useDeviceType";
import { useDashboardModals } from "../../Context/DashboardModalsContext";
import ViewOrder from "../Designer/Components/ViewOrder/ViewOrder";

const Dashboard = () => {
  const theme = useTheme();
  const deviceType = useDeviceType();
  const { orderView, setOrderView } = useDashboardModals();

  const closOrderView = () => {
    setOrderView(false);
  };
  return (
    <Box sx={{ height: { md: "100vh", xs: "120vh" } }}>
      <MainAppBar />
      
      <div className="app">
        {deviceType != "mobile" && <NewSideBar />}
        <main
          className="content"
          style={{
            background: theme.palette.mode === "dark" ? "#161B25" : "#F7FBFF",
            maxHeight: "100vh",
          }}
        >
          <Outlet />
        </main>
      </div>

      {orderView && (
        <Suspense fallback={<div>Loading...</div>}>
          <ViewOrder
            curentStep={20}
            afterClose={closOrderView}
          />
        </Suspense>
      )}
    </Box>
  );
};

export default Dashboard;
